import types from '../constants/types'
import config from '@/config'
// import cookies from 'js-cookie'
import { toQueryString } from '@/utils'
import axios from '@/http'

export const commonAction = {
  fetchCommon({ commit, state }, param, apiParam = config.apiParam) {
    const request = param.request || param.path
    const userToken = window.localStorage.getItem('token')
    commit(types.COMMON_REQUEST, { request: request })
    axios({
      method: 'post',
      url: '/' + param.path,
      transformRequest: [function (data, headers) {
        return toQueryString(data)
      }],
      data: Object.assign({
        token: userToken
      },
      param.data,
      apiParam)
    })
    .then((res) => {
      if (res && res.status === 200) {
        if (res.data.code !== '0' && res.data.code !== '000000') {
          commit(types.COMMON_FAILURE, {
            request: request,
            data: res.data
          })
          if (typeof param.onFail === 'function') {
            param.onFail(res.data)
          }
        } else {
          if (typeof param.onSuccess === 'function') {
            param.onSuccess(res.data)
          }
          commit(types.COMMON_SUCCESS, {
            request: request,
            data: res.data
          })
        }
      }
    })
    .catch((error) => {
      console.error(error)
      commit(types.COMMON_FAILURE, {
        request: request,
        data: error
      })
      if (typeof param.onFail === 'function') {
        param.onFail({msg: JSON.stringify(error)})
      }
    })
  },
  fetchCommonSysset({ commit, state }, param, apiParam = config.apiParam) {
    const request = param.request || param.path
    commit(types.COMMON_REQUEST, { request: request })
    axios({
      method: 'post',
      baseURL: config.serviceHost,
      url: '/' + param.path,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      transformRequest: [function (data, headers) {
        return toQueryString(data)
      }],
      data: Object.assign({},
      param.data,
      apiParam)
    })
      .then((res) => {
        if (res && res.status === 200) {
          if (res.data.code !== '0' && res.data.code !== '000000') {
            commit(types.COMMON_FAILURE, {
              request: request,
              data: res.data
            })
            if (typeof param.onFail === 'function') {
              param.onFail(res.data)
            }
          } else {
            if (typeof param.onSuccess === 'function') {
              param.onSuccess(res.data)
            }
            commit(types.COMMON_SUCCESS, {
              request: request,
              data: res.data
            })
          }
        }
      })
      .catch((error) => {
        commit(types.COMMON_FAILURE, {
          request: request,
          data: error
        })
        if (typeof param.onFail === 'function') {
          param.onFail({msg: JSON.stringify(error)})
        }
      })
  }
}
